import { ConstantUtil } from '@/utils/ConstantUtil';
import settings from '@/utils/settings';

const Utils = {};

const LanguageArray = ConstantUtil.LanguageArray;
const HostArray = ConstantUtil.HostArray;

const LangVal = {};
for (let i = 0; i < LanguageArray.length; i += 1) {
    LangVal[LanguageArray[i].code] = LanguageArray[i].name;
}

const HostMap = {};
for (let i = 0; i < HostArray.length; i += 1) {
    HostMap[HostArray[i].code] = HostArray[i];
}
Utils.validatePassword = (password) => {
    return password <= '~';
};
Utils.getHostByCode = (code) => {
    if (!code || !HostMap[code]) {
        if (process.env.NODE_RUN_ENV === 'PRODUCTION') {
            return HostMap.p4;
        }
        if (process.env.NODE_RUN_ENV === 'TEST') {
            return HostMap.c2;
        }
    } else {
        if (localStorage.getItem('host') !== code) {
            localStorage.setItem('host', code);
        }
        return HostMap[code];
    }
    return false;
};
Utils.getQueryObject = (u) => {
    const url = u == null ? window.location.href : u;
    const search = url.substring(url.lastIndexOf('?') + 1);
    const obj = {};
    const reg = /([^?&=]+)=([^?&=]*)/g;
    search.replace(reg, (rs, $1, $2) => {
        const name = decodeURIComponent($1);
        let val = decodeURIComponent($2);
        val = String(val);
        obj[name] = val;
        return rs;
    });
    if (obj.lang) {
        if (!LangVal[obj.lang]) {
            obj.lang = localStorage.getItem('lang') || 'en';
        }
        localStorage.setItem('lang', obj.lang);
    }
    return obj;
};

Utils.getLangVal = lang => LangVal[lang] || '';

// eslint-disable-next-line camelcase
Utils.changeURLArg = (url, arg, arg_val) => {
    const pattern = `${arg}=([^&]*)`;
    // eslint-disable-next-line camelcase
    const replaceText = `${arg}=${arg_val}`;
    if (url.match(pattern)) {
        let tmp = `/(${arg}=)([^&]*)/gi`;
        // eslint-disable-next-line no-eval
        tmp = url.replace(eval(tmp), replaceText);
        return tmp;
    }
    // eslint-disable-next-line no-useless-escape
    if (url.match('[\?]')) {
        return `${url}&${replaceText}`;
    }
    return `${url}?${replaceText}`;
};
Utils.isIE = () => {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE');
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./)) {
        return true;
    }
    return false;
};
Utils.isEmail = (str) => {
    const reg = /^[A-Za-z0-9._%-]+@([A-Za-z0-9-]+\.)+[A-Za-z]{2,4}$/;
    return reg.test(str);
};
Utils.getDapp = (userid, self) => {
    let accountList = [];
    if (self) {
        accountList = self.$store.state.accountList;
    } else {
        accountList = JSON.parse(localStorage.getItem('j-accountList'));
    }
    const users = accountList.filter((item) => item.userid == userid);
    if (users && users.length > 0 && users[0].inviter && users[0].inviter != '') {
        return users[0].inviter;
    }
    if (settings.dapp && settings.dapp != '') {
        return settings.dapp;
    }
    console.log(settings, '333333');

    return 'Sagittarius';
};


Utils.isPassword = (pass) => {
    const str = pass;
    if (str == null || str.length < 8) {
        return false;
    }
    const reg1 = new RegExp(/^[0-9A-Za-z]+$/);
    if (!reg1.test(str)) {
        return false;
    }
    const reg = new RegExp(/[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/);
    if (reg.test(str)) {
        return true;
    }
    return false;
};
Utils.getToken = (token) => {
    if (token !== '') {
        const tokenInfo = localStorage.getItem(token);
        if (tokenInfo) {
            return JSON.parse(tokenInfo);
        }
    }
    return {};
};
Utils.getSession = () => {
    const session = localStorage.getItem('session');
    if (session) {
        return JSON.parse(session);
    }
    return {};
};
Utils._debounce = (fn, delay) => {
    let timer;
    return function () {
        const th = this;
        const args = arguments;
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            timer = null;
            fn.apply(th, args);
        }, delay);
    };
};
export default Utils;



// WEBPACK FOOTER //
// ./src/utils/Utils.js